module.exports = __webpack_public_path__ + "img/share.79365c69.png";